import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading3, Button } from '@cian/ui-kit';

export interface IMobileViewProps {
  onClick(): void;
}

export const MobileView: React.FC<IMobileViewProps> = ({ onClick }) => {
  return (
    <>
      <div data-testid="MobileViewId" className={styles['title']}>
        <ArticleHeading3>Отлично! Отчёт доступен по ссылке</ArticleHeading3>
      </div>
      <Button theme="fill_primary" size="M" onClick={onClick} fullWidth>
        Поделиться
      </Button>
    </>
  );
};

MobileView.displayName = 'MobileView';
